import { UiModStickyScroll } from '@/fo/ui/mod/sticky/scroll';

import { styles } from './UiCartLayoutPage.styles';

export type SlotNameProps =
  | 'title'
  | 'products'
  | 'delivery'
  | 'summary'
  | 'stickyButton';

export interface UiCartLayoutPageProps {
  className?: string;
  slots: Partial<Record<SlotNameProps, React.ReactNode>>;
  variant?: 'checkout' | 'cartDrawer';
}
export interface UiCartLayoutPagePropsWithClassName {
  className?: string;
  slots: Partial<Record<SlotNameProps, React.ReactNode>>;
}

export function UiCartLayoutPage({
  slots: slotsMap,
  className,
  variant = 'cartDrawer'
}: UiCartLayoutPageProps) {
  const slots = styles({ variant });

  return (
    <div className={slots.base()}>
      <div className={slots.cart({ className })}>
        <div className={slots.common()}>
          <div className={slots.top()}>
            {slotsMap.title}
            {slotsMap.delivery}
          </div>

          {slotsMap.products}
        </div>

        <UiModStickyScroll
          className={slots.sidebar({
            className: [
              '[--offset-top:calc(var(--head-fixed-height)+20px)]',
              '[--offset-bottom:20px]',
              'max-lg:[--inactive:1]'
            ]
          })}
        >
          <div className={slots.sidebarInner()}>{slotsMap.summary}</div>
        </UiModStickyScroll>
      </div>

      {slotsMap.stickyButton && slotsMap.stickyButton}
    </div>
  );
}
